import { render, staticRenderFns } from "./wechatdedit.vue?vue&type=template&id=89198f16&scoped=true"
import script from "./wechatdedit.vue?vue&type=script&lang=js"
export * from "./wechatdedit.vue?vue&type=script&lang=js"
import style0 from "./wechatdedit.vue?vue&type=style&index=0&id=89198f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89198f16",
  null
  
)

export default component.exports